import QueryLink from './QueryLink';

const VerifyIdLink = QueryLink({ modal: 'verify-id' });

export default VerifyIdLink;
